import { RichTextType } from '../../../resources/modelTypes';
import ThemeExtractor from '../../../core/components/ThemeExtractor';
import { css } from '@emotion/react';
import RichTextRenderer from '../../../forms/components/RichText/RichTextRenderer';
import React, { memo } from 'react';

export type ThemedRichTextProps = {
  content: RichTextType,
}

const ThemedRichText = ({
  content,
}: ThemedRichTextProps) => (
  <ThemeExtractor
    rules={
      [
        'linkColor',
      ]
    }
  >
    {
      ({
        linkColor,
      }) => (
        <div
          css={
            css`
            a {
              color: ${linkColor};
            }
          `
          }
        >
          <RichTextRenderer value={content} />
        </div>
      )
    }
  </ThemeExtractor>
);

const MemoizedThemedRichText = memo(ThemedRichText);

export { MemoizedThemedRichText as ThemedRichText };
